// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"description_wrapper__vCSG7","description":"description_description__2MQ5R","icon":"description_icon__1WoZ4"};